import React from "react";

import { Grid } from "@mui/material";

import TransitionHeader from "../ui/TransitionHeader";
import TransitionLinksCard, { LinkItem } from "../ui/TransitionLinksCard";

// Real tools data based on provided "Tools for Working at Farther" table
const toolsData: LinkItem[][] = [
  [
    {
      title: "Gmail",
      subtitle: "For company email",
      url: "https://mail.google.com",
    },
  ],
  [
    {
      title: "HubSpot",
      subtitle: "For CRM",
      url: "https://app.hubspot.com/login",
    },
  ],
  [
    {
      title: "Slack",
      subtitle: "For messaging",
      url: "https://slack.com/signin#/signin",
    },
  ],
  [
    {
      title: "Google Drive",
      subtitle: "For document creation and file storage",
      url: "https://drive.google.com/",
    },
  ],
  [
    {
      title: "Rippling",
      subtitle: "For HR and benefits",
      url: "https://app.rippling.com",
    },
  ],
  [
    {
      title: "Farther Knowledge Base",
      subtitle: "For internal documentation and FAQs",
      url: "https://www.notion.so/Welcome-to-Farther-ac5ee11249a040959c35d4c780d5ea1c?pvs=21",
    },
  ],
];

const TransitionTools: React.FC = () => {
  return (
    <div>
      <TransitionHeader
        title="Tools for Working at Farther"
        subtitle="Apps that we use day-to-day for work"
      />
      <Grid container spacing={2}>
        {toolsData.map((links, index) => (
          <Grid item xs={12} md={6} key={`tools-${index}`}>
            <TransitionLinksCard links={links} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default TransitionTools;
